<template>
  <v-card v-if="affiliation">
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">
          {{ $t("screener.affiliation.title") }}
        </div>
        <span class="body-1 greyDarken1--text">{{
          $t("screener.affiliation.update.subtitle")
        }}</span>
      </div>
      <v-spacer></v-spacer>
      <!-- No need of deletion -->
      <!-- <ConfirmationDialog
        :headline="'screener.affiliation.delete.confirmation.dialog.title'"
        :desc="'screener.affiliation.delete.confirmation.dialog.desc'"
        :action="getDialogAction(affiliation.id, 'rms_delete', 'error')"
        :button_type="'button'"
      ></ConfirmationDialog> -->
    </v-card-title>
    <v-card-text class="pb-0">
        <AffiliationSummary
        :affiliation="affiliation">
        </AffiliationSummary>
        <v-divider class="my-4"></v-divider>
        <!-- How to use affiliation, instructions -->
        <AffiliationHowToUse
        :url="currentCompany.domain"
        :code="affiliation.code"
        ></AffiliationHowToUse>
        <v-divider class="my-4"></v-divider>
        <!-- For updating affiliation form -->
        <AffiliationForm
        :affiliation.sync="affiliation"
        ref="affiliationForm">
        </AffiliationForm>
    </v-card-text>
    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn
        @click.stop="goToAffiliationListPage"
        color="grey"
        dark
      >
        {{ $t("rms.button.cancel") }}
      </v-btn>
      <v-btn dark color="secondary"
        @click.stop="onUpdate()"
        :loading="loading"
        :disabled="loading">
        {{ $t("rms.button.update") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import AffiliationForm from "@/components/affiliation/Form";
import AffiliationSummary from "@/components/affiliation/Summary";
import AffiliationHowToUse from "@/components/affiliation/HowToUse";

export default {
  name: "AffiliationSave",
  components: {
    ConfirmationDialog,
    AffiliationForm,
    AffiliationSummary,
    AffiliationHowToUse
  },
  data() {
    return {
      affiliation: null,
      loading:false
    };
  },
  async beforeRouteEnter(to, from, next) {
    await next(vm => {
      vm.getAffiliation();
    });
  },
  computed: {
    ...mapGetters("company", {
      timezone: "getSelectedCompanyTimezone",
      currentCompany:"getSelectedCompany"
    })
  },
  methods: {
    async getAffiliation() {
        try {
            // If available in store get from there else from server
            var affiliation = await this.$store.dispatch("affiliation/get", {
                id: this.$route.params.affiliation_id
            });
            this.affiliation = affiliation;
        } catch (error) {
            this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: "error"
            });
        }
    },
    async onUpdate() {
      try {
          this.loading = true;
          if(!this.$refs.affiliationForm.validate()){
              return;
          }
          var resposne = await this.$store.dispatch("affiliation/update", this.affiliation);
          this.affiliation = resposne.affiliation;
          this.$store.dispatch("app/showMessage", {
              message: "Updated successfully!",
              color: "success"
          });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
        });
      }finally{
        this.loading = false;
      }
    },
    goToAffiliationListPage(){
      this.$router.push({
        name: "affiliations.index",
        params: {
          company_id: this.currentCompany.id
        }
      });
    },
    async onDelete(affiliation_id) {
      try {
          await this.$store.dispatch("affiliation/delete", {
            id: affiliation_id
          });
          this.goToAffiliationListPage();
      } catch (error) {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
      }
    },
    getDialogAction(update_status, btn_icon, btn_color) {
      return {
        button_icon: btn_icon,
        button_color: btn_color,
        method: this.onDelete,
        payload: update_status,
        button_label:this.$t('rms.button.delete')
      };
    },
  }
};
</script>


